import React, { useEffect } from 'react';
import CohortDictionary from '../CohortDictionary';
import { pageViewed } from '../../../utils/analytics/events/page/events';
import { useAnalytics } from '../../../utils/analytics/useAnalytics';

const ViewCohorts = () => {
  const { track } = useAnalytics();
  useEffect(() => {
    track(
      pageViewed({
        category: 'cohorts',
        name: 'view cohorts',
        id: null,
      }),
    );
  }, [track]);

  return <CohortDictionary />;
};

export default ViewCohorts;
